// TODO SYLING

import React from 'react';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';
import { IAccountContext } from '../../../context/account/account.context';
import { Link, navigate } from 'gatsby';

import * as StylesHs from './navigation-customer.hs.module.scss';
import * as StylesDr from './navigation-customer.dr.module.scss';
import { TopNavigationStoryblok } from '../../../_shared/interfaces/storyblok';
import { getMultilinkURL } from '../../../lib/helpers/helpers';

const NavigationCustomer = ({
    blok,
    storyblokCommon,
    navigationId = 'navigation',
    accountContext,
    onClose,
}: {
    blok: TopNavigationStoryblok;
    storyblokCommon: StoryblokCommon;
    navigationId?: string;
    accountContext: IAccountContext;
    onClose?: () => any;
}) => {
    const configuration = storyblokCommon.configuration.content;
    const styles = configuration.theme === 'dr' ? StylesDr : StylesHs;
    const isHSTheme = configuration.theme === 'hs';
    const accountPageUrl = getMultilinkURL(blok.account_link);

    const close = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <div id={navigationId + '-customer-wrapper-' + blok._uid} className={styles.navigationItemWrapper}>
            <div id={navigationId + '-customer-' + blok._uid} className={[styles.navigationItem].join(' ')}>
                <div id={navigationId + '-headline-' + blok._uid} className={styles.navigationItemHeadline}>
                    <button
                        role="menuitem"
                        id={navigationId + '-button-' + blok._uid}
                        aria-controls={navigationId + '-' + blok._uid}
                        onClick={() => {
                            close();
                        }}
                    >
                        {isHSTheme ? (
                            <>{accountContext.account ? <span>{blok.navigation_text}</span> : <span>{blok.navigation_text_log_in}</span>}</>
                        ) : (
                            <span>{blok.navigation_text}</span>
                        )}
                    </button>
                </div>

                <div id={navigationId + '-value-' + blok._uid} role="none">
                    {!accountContext.account ? (
                        <>
                            {blok.log_in && (
                                <button
                                    id={navigationId + '-sign-in-' + blok._uid}
                                    onClick={() => accountContext.signIn(configuration.language, configuration.theme)}
                                    className={styles.iconLogin}
                                >
                                    {blok.log_in}
                                </button>
                            )}

                            {blok.register && (
                                <button
                                    id={navigationId + '-sign-up-' + blok._uid}
                                    onClick={() => accountContext.signUp(configuration.language, configuration.theme)}
                                >
                                    {blok.register_prefix && (
                                        <>
                                            <strong id={navigationId + '-sign-up-strong-' + blok._uid}>{blok.register_prefix}</strong>{' '}
                                        </>
                                    )}
                                    {blok.register}
                                </button>
                            )}

                            {blok.register_advantages && (
                                <Link
                                    id={navigationId + '-link-register-advantages-' + blok._uid}
                                    to={getMultilinkURL(blok.register_advantages_link)}
                                    className={styles.borderTop}
                                >
                                    {blok.register_advantages}
                                </Link>
                            )}
                        </>
                    ) : (
                        <>
                            {configuration.account_navigation_profile && (
                                <Link
                                    id={navigationId + '-link-profile-' + blok._uid}
                                    to={accountPageUrl}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(accountPageUrl, {
                                            state: { pageId: 'Profile' },
                                        });
                                        close();
                                    }}
                                >
                                    {configuration.account_navigation_profile}
                                </Link>
                            )}

                            {configuration.account_navigation_addresses && (
                                <Link
                                    id={navigationId + '-link-addresses-' + blok._uid}
                                    to={accountPageUrl}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(accountPageUrl, {
                                            state: { pageId: 'Addresses' },
                                        });
                                        close();
                                    }}
                                >
                                    {configuration.account_navigation_addresses}
                                </Link>
                            )}

                            {configuration.account_navigation_devices && (
                                <Link
                                    id={navigationId + '-link-devices-' + blok._uid}
                                    to={accountPageUrl}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(accountPageUrl, {
                                            state: { pageId: 'Devices' },
                                        });
                                        close();
                                    }}
                                >
                                    {configuration.account_navigation_devices}
                                </Link>
                            )}

                            {configuration.account_navigation_promocode && (
                                <Link
                                    id={navigationId + '-link-promocode-' + blok._uid}
                                    to={accountPageUrl}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(accountPageUrl, {
                                            state: { pageId: 'Promocode' },
                                        });
                                        close();
                                    }}
                                >
                                    {configuration.account_navigation_promocode}
                                </Link>
                            )}

                            {configuration.account_navigation_contract_data && (
                                <Link
                                    id={navigationId + '-link-contract-data-' + blok._uid}
                                    to={accountPageUrl}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(accountPageUrl, {
                                            state: { pageId: 'ContractData' },
                                        });
                                        close();
                                    }}
                                >
                                    {configuration.account_navigation_contract_data}
                                </Link>
                            )}

                            {configuration.account_navigation_cost_estimates && (
                                <Link
                                    id={navigationId + '-link-cost-estimates-' + blok._uid}
                                    to={accountPageUrl}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(accountPageUrl, {
                                            state: { pageId: 'CostEstimates' },
                                        });
                                        close();
                                    }}
                                >
                                    {configuration.account_navigation_cost_estimates}
                                </Link>
                            )}

                            {blok.log_out && (
                                <button
                                    id={navigationId + '-sign-up-' + blok._uid}
                                    onClick={accountContext.signOut}
                                    className={[styles.iconLogout, styles.borderTop].join(' ')}
                                >
                                    {blok.log_out}
                                </button>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NavigationCustomer;
